import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './components/Auth/Login';
import ForgotPassword from './components/Auth/ForgotPassword';
import Dashboard from './components/Dashboard/Dashboard';
import LeadGeneration from './components/Dashboard/LeadGeneration';
import LeadsList from './components/Dashboard/LeadsList';
import Help from './components/Help/Help';
import './App.css';
import AdminDashboard from './components/admin/AdminDashboard';

const ProtectedRoute = ({ children, adminOnly = false }) => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && currentUser.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

// Route handler that redirects based on user role
const DashboardRouter = () => {
  const { currentUser } = useAuth();

  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Redirect admin to admin dashboard
  if (currentUser.role === 'admin') {
    return <Navigate to="/admin" replace />;
  }

  // Regular users go to normal dashboard
  return <Dashboard />;
};

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/generate-lead" element={
            <ProtectedRoute>
              <LeadGeneration />
            </ProtectedRoute>
          } />
<Route path="/admin" element={<ProtectedRoute>
<AdminDashboard /></ProtectedRoute>} />
          <Route path="/leads" element={
            <ProtectedRoute>
              <LeadsList />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <Help />
            </ProtectedRoute>
          } />
          <Route path="/" element={<Navigate to="/login" />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;